<!-- eslint-disable max-len -->
<template>
  <v-stepper-content step="B1">
    <v-dialog
      v-model="uploadDialog"
      max-width="600px"
      persistent
    >
      <DocumentsDesktop
        v-bind:categoryTitle="categoryTitle"
        v-bind:categoryDescription="categoryDescription"
        v-bind:category="categoryKey"
        v-bind:type="categoryType"
        v-bind:files="documents"
        v-on:setDialog="uploadDialog = $event"
      ></DocumentsDesktop>
    </v-dialog>
    <v-col
      cols="12"
      :class="$vuetify.breakpoint.name !== 'sm' ? 'd-flex justify-center mx-0 px-0' : 'd-flex justify-center'"
    >
      <v-card
        flat
        outlined
        rounded="lg"
        :max-width="$vuetify.breakpoint.name === 'xs' ? '95vw' : '75vw'"
        min-height="500px"
      >
        <v-row :class="$vuetify.breakpoint.name === 'xs' ? 'mt-8 mx-1' : 'mt-8 mx-5'">

          <v-col cols="12">
            <div class="text-md-h4 text-h5" :style="textColor">Introduction to Benefits</div>
          </v-col>
          <v-col cols="12">
            <div>At Landrum, our goal is to find your company the most cost-effective and appropriate benefits solutions. Please answer the following questions concerning your employees and their dependents. Remember to include the total count of employees of all statuses and their dependents.</div>
          </v-col>

          <v-col
            cols="12"
            class="mt-5"
          >
            <div class="text-md-body-1 text-body-2">This includes:</div>
            <v-list color="transparent">
              <v-list-item style="min-height: 32px;">
                <v-list-item-content class="pb-0">
                  <v-list-item-title>Active</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item style="min-height: 32px;">
                <v-list-item-content class="pb-0 pt-0">
                  <v-list-item-title>Inactive/Not Working</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item style="min-height: 32px;">
                <v-list-item-content class="pb-0 pt-0">
                  <v-list-item-title>On Leave</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item style="min-height: 32px;">
                <v-list-item-content class="pb-0 pt-0">
                  <v-list-item-title>COBRA recipients</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item style="min-height: 32px;">
                <v-list-item-content class="pt-0">
                  <v-list-item-title style="white-space: normal;">State-mandated healthcare recipients</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col
            cols="12"
            class="mt-5"
          >
            <div class="text-md-body-1 text-body-2">*Do you currently provide benefits to your employees?</div>
          </v-col>

          <v-col cols="12" class="pt-0">
            <!-- <v-btn-toggle
              :color="benefitsChoice ? 'green' : 'pink'"
              mandatory
              v-model="benefitsChoice"
            >
              <v-btn
                :value="true"
              >
                Yes
              </v-btn>
              <v-btn
                :value="false"
              >
                No
              </v-btn>
            </v-btn-toggle> -->
            <v-radio-group
              v-model="benefitsChoice"
              row
              class="mt-0"
            >
              <v-radio
                label="Yes"
                :value="true"
              ></v-radio>
              <v-radio
                label="No"
                :value="false"
              ></v-radio>
            </v-radio-group>
          </v-col>

          <!-- Documents -->
          <v-col
            cols="12"
            class="mt-5"
          >
            <div class="text-md-body-1 text-body-2">In order to receive a health insurance quote, please upload the below documents:</div>
            <v-list class="mt-3" color="transparent" style="width: fit-content;">

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title style="white-space: normal;">Please download our <a href="https://landrumhr.com/Content/Downloads/LHR_Census_Template.xlsx">employee census spreadsheet</a> for uploading your employee information.</v-list-item-title>
                  <v-list-item-title style="white-space: normal;">Remember to include the total count of employees of all statuses and their dependents</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!-- Button1 -->
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title style="white-space: normal;">Employee census for benefits</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    color="secondary"
                    outlined
                    @click="setBenefitsEmpCensus"
                  >
                    Upload
                  </v-btn>
                  <v-list-item-action-text
                    v-for="(item, index) in benefitsEmpCensus"
                    :key="index"
                  >
                    {{ item.name }}
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>

              <!-- Button2 -->
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title style="white-space: normal;">A copy of your most recent health insurance billing statement, or PEO payroll register indicating benefits deductions</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    color="secondary"
                    outlined
                    @click="setHealthBillingStatement"
                  >
                    Upload
                  </v-btn>
                  <v-list-item-action-text
                    v-for="(item, index) in healthBillingStatement"
                    :key="index"
                  >
                    {{ item.name }}
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>

              <!-- Button3 -->
              <v-list-item v-show="benefitsChoice === true">
                <v-list-item-content>
                  <v-list-item-title style="white-space: normal;">A copy of your summary of benefits (SBC) 1 per plan</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    color="secondary"
                    outlined
                    @click="setSBC"
                  >
                    Upload
                  </v-btn>
                  <v-list-item-action-text
                    v-for="(item, index) in benefitsSummary"
                    :key="index"
                  >
                    {{ item.name }}
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>

              <!-- Button4 -->
              <v-list-item v-show="benefitsChoice === true">
                <v-list-item-content>
                  <v-list-item-title style="white-space: normal;">A copy of your Employee Benefits Guide</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    color="secondary"
                    outlined
                    @click="setBenefitsGuide"
                  >
                    Upload
                  </v-btn>
                  <v-list-item-action-text
                    v-for="(item, index) in benefitsGuide"
                    :key="index"
                  >
                    {{ item.name }}
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>

              <!-- Button5 -->
              <v-list-item v-show="benefitsChoice === true">
                <v-list-item-content>
                  <v-list-item-title style="white-space: normal;">A copy of your current health insurance rates</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    color="secondary"
                    outlined
                    @click="setHealthInsuranceRates"
                  >
                    Upload
                  </v-btn>
                  <v-list-item-action-text
                    v-for="(item, index) in healthInsuranceRates"
                    :key="index"
                  >
                    {{ item.name }}
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>

              <!-- Button6 -->
              <v-list-item v-show="benefitsChoice === true">
                <v-list-item-content>
                  <v-list-item-title style="white-space: normal;">A copy of your most recent (previous year or upcoming) carrier or PEO generated renewal package</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    color="secondary"
                    outlined
                    @click="setHealthInsuranceRenewalPackage"
                  >
                    Upload
                  </v-btn>
                  <v-list-item-action-text
                    v-for="(item, index) in healthInsuranceRenewalPackage"
                    :key="index"
                  >
                    {{ item.name }}
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>

            </v-list>
          </v-col>
          <v-col cols="12">
            <div class="text-subtitle-2 font-italic">Landrum does not guarantee any specific rates, benefit levels, savings, or carriers to any client or prospective client.</div>
          </v-col>

          <BenefitsBtnContinue />
        </v-row>
      </v-card>
    </v-col>
  </v-stepper-content>
</template>

<script>
import { ref } from 'vue';
import DocumentsDesktop from '@/components/Prospect/DocumentsDesktop.vue';
import BenefitsBtnContinue from './btnBenefitsContinue.vue';

export default {
  name: 'BenefitsStepOne',
  components: {
    BenefitsBtnContinue,
    DocumentsDesktop,
  },
  data: () => ({
    uploadDialog: false,
    categoryTitle: '',
    categoryDescription: '',
    categoryKey: '',
    categoryType: 'Benefits',
  }),
  computed: {
    textColor() {
      if (this.$vuetify.theme.dark) {
        return 'color: #ffffff';
      }

      return 'color: #2a4f66';
    },
    documents() {
      let files = null;
      switch (this.categoryKey) {
        case 'BenefitsEmpCensus':
          files = ref(this.benefitsEmpCensus);
          break;
        case 'BenefitsSummary':
          files = ref(this.benefitsSummary);
          break;
        case 'HealthBillingStatement':
          files = ref(this.healthBillingStatement);
          break;
        case 'BenefitsGuide':
          files = ref(this.benefitsGuide);
          break;
        case 'HealthInsuranceRates':
          files = ref(this.healthInsuranceRates);
          break;
        case 'HealthInsuranceRenewalPackage':
          files = ref(this.healthInsuranceRenewalPackage);
          break;
        default:
          files = null;
          break;
      }
      return files;
    },
    healthInsuranceRenewalPackage() {
      return this.filterBenefitsDocuments('HealthInsuranceRenewalPackage');
    },
    healthInsuranceRates() {
      return this.filterBenefitsDocuments('HealthInsuranceRates');
    },
    benefitsGuide() {
      return this.filterBenefitsDocuments('BenefitsGuide');
    },
    healthBillingStatement() {
      return this.filterBenefitsDocuments('HealthBillingStatement');
    },
    benefitsEmpCensus() {
      return this.filterBenefitsDocuments('BenefitsEmpCensus');
    },
    benefitsSummary() {
      return this.filterBenefitsDocuments('BenefitsSummary');
    },
    benefitsChoice: {
      get() {
        return this.$store.state.benefitsPacket.flags.benefitsAlreadyProvided;
      },
      set(value) {
        this.$store.commit('updateBenefitsAlreadyProvided', value);
      },
    },
  },
  methods: {
    filterBenefitsDocuments(categoryKey) {
      const { documents } = this.$store.state.benefitsPacket;
      const document = documents.filter((x) => x.category === categoryKey);
      if (document === undefined) {
        return '';
      }
      return document;
    },
    setBenefitsEmpCensus() {
      this.categoryTitle = 'Employee census for benefits';
      this.categoryDescription = 'Delete and upload files.';
      this.categoryKey = 'BenefitsEmpCensus';
      this.uploadDialog = true;
    },
    setSBC() {
      this.categoryTitle = 'Summary of Benefits (SBC)';
      this.categoryDescription = 'Delete and upload files. 1 file per plan.';
      this.categoryKey = 'BenefitsSummary';
      this.uploadDialog = true;
    },
    setHealthInsuranceRenewalPackage() {
      this.categoryTitle = 'Health Insurance Renewal Package';
      this.categoryDescription = 'Upload any files that pertain to your health insurance renewals';
      this.categoryKey = 'HealthInsuranceRenewalPackage';
      this.uploadDialog = true;
    },
    setHealthBillingStatement() {
      this.categoryTitle = 'Benefit Deductions';
      // eslint-disable-next-line max-len
      this.categoryDescription = 'Upload files that contain benefits deductions:\nCan be found in your most recent health insurance billing statement or PEO payroll register';
      this.categoryKey = 'HealthBillingStatement';
      this.uploadDialog = true;
    },
    setBenefitsGuide() {
      this.categoryTitle = 'Benefits Guide';
      this.categoryDescription = 'Upload any files that pertain to your Employee Benefits Guide';
      this.categoryKey = 'BenefitsGuide';
      this.uploadDialog = true;
    },
    setHealthInsuranceRates() {
      this.categoryTitle = 'Benefits Guide';
      this.categoryDescription = 'Upload any files that pertain to your health insurance rates';
      this.categoryKey = 'HealthInsuranceRates';
      this.uploadDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
